<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { Task } from "@/types/v2";
import { useTasksStore } from "@/stores/v2";
import { TasksService } from "@/services/v2/tasks";
import { normalizeRouteParam } from "@/utils/v2/routes"
import { useLoading } from "@/composables/useLoading";

import Filters from "@/components/v2/Dashboard/Tasks/Filters/TasksFilter.vue";
import TaskList from "@/components/v2/Dashboard/Tasks/Lists/TasksList.vue";
import LayoutMain from "@/components/v2/Layouts/LayoutMain.vue";
import LoadingScreen from "@/components/v2/Loaders/LoadingScreen.vue";

const { withLoading, isLoading } = useLoading();

const route = useRoute();
const siteKey = normalizeRouteParam(route.params.key)
const tasks = computed(() => useTasksStore().getTasksByActiveFilters)

const init = async () => {
  await withLoading(async () => {
    const tasks: Task[] = await TasksService.getTasksBySiteKey(siteKey);
    if (tasks) useTasksStore().setTasks(tasks);
  })
}

onMounted(init)
</script>

<template>
  <LoadingScreen v-if="isLoading" :text="'Loading tasks'" />
  <LayoutMain v-else>
    <template #mainArea>
      <Filters class="mb-10" />
      <TaskList :tasks="tasks" />
    </template>
  </LayoutMain>
</template>
